import styles from './SquareItem.scss';

import cx from 'classnames';
import React from 'react';

import { ContentType, ModalLink, ModalType, as } from 'src/api/contentful/contentTypes.cloverdotcom';
import { ContentLink } from 'src/components/ContentLink/ContentLink';
import { getField, isEntry } from 'src/utils/EntryUtil';

import { Card, ICardProps } from '../../Card/Card';
import { EnhancedMedia } from '../../EnhancedMedia/EnhancedMedia';
import { TextStack } from '../../TextStack/TextStack';

export interface ItemState {
  modalOpen: boolean;
  noVideo: boolean;
}

export class Item extends React.Component<ICardProps, ItemState> {

  readonly state: ItemState = { modalOpen: false, noVideo: false };

  readonly enhancedMedia = React.createRef<EnhancedMedia>();

  static getDerivedStateFromProps(props: Readonly<ICardProps>, state: Readonly<ItemState>) {
    const video = getField(props.entry, 'video');
    if (!video && !state.noVideo) {
      // determines cursor and onClick logic
      return {
        ...state,
        noVideo: true,
      };
    }

    return state;
  }

  render() {
    const { entry, style, tabIndex, preload, forceImage, mediaProps, className, ...props } = this.props;  // Ignoring the styles that react-slick passes down

    if (!isEntry(entry)) return null;

    const link = getField(entry, 'link');
    const modal = getField(as<ModalLink>(ContentType.MODAL_LINK, link), 'modal');

    return (
      <ContentLink
        hideTitle
        alwaysRenderChildren
        entry={link}
        className={cx(styles.squareItem, className)}
        tabIndex={tabIndex}
      >
        <Card
          onMouseEnter={this.handleMouseEnter}
          onMouseLeave={this.handleMouseLeave}
          entry={entry}
          mediaClassName={styles.imageWrapper}
          captionClassName={styles.cardCaption}
          enhancedMediaRef={this.enhancedMedia}
          forceImage={forceImage}
          preload={preload}
          mediaProps={{
            muted: true,
            autoPlay: false,
          }}
          {...props}
        >
          <TextStack
            forceLinkAsSpan
            entry={entry}
            titleTagName="h5"
            linkClassName={cx(styles.itemLink, {
              [styles.itemLinkHidden]: getField(modal, 'type') === ModalType.MediaOnly,
            })}
            blurbClassName={styles.itemText}
            className={styles.itemContent}
            showLinkArrow
          />
        </Card>
      </ContentLink>
    );
  }

  handleMouseEnter = () => {
    const { current } = this.enhancedMedia;
    if (current) {
      current.play();
    }
  };

  handleMouseLeave = () => {
    const { current } = this.enhancedMedia;
    if (current) {
      current.pause();
      current.reloadMedia(); // force-reload media so background image gets shown again
    }
  };
}
